// driving_school_classroom_type_setup_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "locationTypeInPerson",
    "locationTypeRemote",
    "locationTypeOptionInPerson",
    "locationTypeOptionRemote",
    "locationTypeOptionBoth",
    "gapBetweenSessions"
  ]

  updateSessionsPerDay(event) {
    const sessionsPerDay = Number(event.target.value);
    const showGapField = Number.isInteger(sessionsPerDay) && sessionsPerDay > 1;
    
    this.gapBetweenSessionsTarget.classList.toggle("u-hidden", !showGapField);
  }

  updateLocationType() {
    if (this.locationTypeOptionInPersonTarget.checked) {
      this.locationTypeInPersonTarget.classList.remove("u-hidden");
      this.locationTypeRemoteTarget.classList.add("u-hidden");
    }

    if (this.locationTypeOptionRemoteTarget.checked) {
      this.locationTypeInPersonTarget.classList.add("u-hidden");
      this.locationTypeRemoteTarget.classList.remove("u-hidden");
    }

    if (this.locationTypeOptionBothTarget.checked) {
      this.locationTypeInPersonTarget.classList.remove("u-hidden");
      this.locationTypeRemoteTarget.classList.remove("u-hidden");
    }
  }

  validate(event) {
    const errors = this.validateForm();
    
    if (errors.length > 0) {
      event.preventDefault();
      this.showValidationBlock(errors.join("<br>"));
      return;
    }    
  }

  validateForm() {
    let validationErrors = [];

    let fieldsToValidate = [
      { id: "driving_school_classroom_type_name", 
        name: "Name", 
        validation: "required" 
      },
      { id: "driving_school_classroom_type_number_of_sessions", 
        name: "Total sessions", 
        validation: "required|positiveNumber" 
      },
      { id: "driving_school_classroom_type_number_of_sessions_per_day", 
        name: "Sessions per day", 
        validation: "required|positiveNumber" 
      },
      { 
        id: "driving_school_classroom_type_gap_between_sessions_in_minutes", 
        name: "Session gap (mins)", 
        hidden: this.gapBetweenSessionsTarget.classList.contains('u-hidden'),
        validation: "required|positiveNumber" 
      },
      { 
        id: "driving_school_classroom_type_max_number_of_in_person_attendees", 
        name: "Max attendees", 
        hidden: this.locationTypeInPersonTarget.classList.contains('u-hidden'), 
        validation: "required|positiveNumber" 
      },
      { 
        id: "driving_school_classroom_type_max_number_of_remote_attendees", 
        name: "Max remote attendees", 
        hidden: this.locationTypeRemoteTarget.classList.contains('u-hidden'), 
        validation: "required|positiveNumber" 
      }
    ];

    fieldsToValidate.forEach(field_data => {
      if (!field_data.hidden) {
        let field = document.getElementById(field_data.id);
        
        if (field) {
          let value = field.value;
          let validationRules = field_data.validation.split('|');
    
          for (let rule of validationRules) {
            switch (rule) {
              case 'required':
                if (!value) {
                  validationErrors.push(`${field_data.name} is required.`);
                  return;
                }
                break;
    
              case 'positiveNumber':
                if (value === "") {
                  validationErrors.push(`${field_data.name} cannot be empty.`);
                  return;
                } else if (isNaN(value) || Number(value) <= 0) {
                  validationErrors.push(`${field_data.name} must be greater than 0.`);
                  return;
                }
                break;
            }
          }
        }
      }
    });
    
    return validationErrors;
  }

  showValidationBlock(message) {
    const validationBlock = document.getElementById("validation-block");
    const validationMessage = document.getElementById("validation-message");
  
    validationMessage.innerHTML = message;
    validationBlock.hidden = false;
    validationMessage.hidden = false;
  }
}

